module.exports = __webpack_public_path__ + "templates-59e97cd7/template-1-preview-78faf19c2fc1b3c1ee6790e6dcd0ebdb.jpg";